import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import EmployeeCarousel from "./components/EmployeeCarousel";
import { Link } from "react-router";

let OurStory = React.createClass({
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Our story";
        }
    },
    render() {
        return (
            <section className="eo-view our-story">
                <Hero className="our-story-hero">
                    <h1><span>WiFi is not</span> <span>a four-letter word</span></h1>
                    <Link to="/jobs" className="eo-btn-outline white hover-blue">Join us</Link>
                </Hero>

                <div className="eo-padded-wrapper">
                    <section className="eo-section grid-10 eo-info intro">
                        <h2 className="standard grid-10">Building 21st-century WiFi</h2>

                        <div className="eo-text-group grid-10 intro-text">
                            <p className="standard eo-info-copy">Everything in our homes is coming online: speakers, thermostats, light bulbs, grandma, front doors, cameras, washers, dryers, and
                                everything in between. And WiFi is the foundation for it all. Outside the smartphone, it’s the technology we depend on most — the utility of the 21st-century home. It
                                powers not only our work but also many of our favorite activities — Netflix, your Apple TV, your Sonos speakers.</p>

                            <p className="standard eo-info-copy">But at best, WiFi is like death by a thousand cuts: dead zones, painful setup, embarrassing passwords, equipment that you have to hide
                                in the closet. At worst, it’s complete failure.</p>
                        </div>
                        <img src="/public/img/our-story/product.png" className="hide-s eo-img-fluid"/>
                    </section>
                    <section className="eo-section grid-10 eo-info">
                        <h2 className="grid-10">Sleek. Refined. Understated</h2>
                        <p className="eo-info-copy">The hardware’s not bad either.</p>
                    </section>
                </div>
                <EmployeeCarousel/>
                <div className="grid-10 eo-padded-wrapper jobs-wrapper">
                    <section className="grid-10 eo-section eo-cta big-cta jobs">
                        <div className="eo-cta-content">
                            <h3 className="eo-cta-header"><span className="big-text eo-cta-header-group">GEEK OUT<br/>ON WIFI?</span></h3>
                            <h4>SPOILER ALERT: SO DO WE</h4>
                            <Link to="jobs" className="eo-btn-outline white hover-blue">Join us</Link>
                        </div>
                    </section>
                </div>
            </section>
        );
    }
});

export default Marty.createContainer(OurStory, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/our-story/Handler.js
 **/